import React from "react";
import "./Feedback2.css";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
// import NewHeader from "../../components/NewHeader/NewHeader";
// import Footer from "../../components/Footer/Footer";
import SubFooter from "../../components/SubFooter/SubFooter";

const Feedback2 = () => {
  const history = useHistory();
  return (
    <>
      {/* <NewHeader /> */}

      <div className="feedbackMain2">
        <img
          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/5f01bcf9-bf39-4ee6-93ae-da956b7897ae.svg"
          alt="FeedbackImageAlt"
        />
        <span>Thank You For Your Feedback</span>
        <p>This will help us provide you with better services</p>
        <button type="button" onClick={() =>
          // history.push('/')
          window.location.href = process.env.RAZZLE_APP_BASE_URL
        }>
          BACK TO HOMEPAGE

        </button>

      </div>
      {/* <Footer />
      <SubFooter/> */}
    </>
  );
};
export default {
  component: Feedback2,
};
